<template>
    <div>
        <div class="bulk-floating-action-wrapper">
            <div class="actions" :class="{ 'loading-opacity': loading }">

                <app-overlay-loader v-if="loading" />

                <template v-else>
                    <app-context-button icon="map" :title="this.$t('actions')">
                        <a href="#" class="dropdown-item" @click="openEventModal()">
                            {{ this.$t('change_selected_trucks_position') }}
                        </a>
                    </app-context-button>
                    <!-- <app-context-button icon="calendar" :title="this.$t('actions')">
                        <a href="#" class="dropdown-item" @click="openActionModal('joining_date')">
                            {{ this.$t('add_exit_date_for_selected_trucks') }}
                        </a>
                    </app-context-button> -->
                </template>

            </div>
        </div>
        <!-- Additional Components -->
        <bulk-truck-event-modal v-if="isTruckEventModalActive" @close-modal="closeBulkTruckEventModal" :trips="trips" />
    </div>
</template>

<script>
// import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
// import { axiosPost } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "ContextMenu",
    components: {},
    mixins: [],
    props: {
        trips: {
            type: Array
        }
    },
    data() {
        return {
            confirmationModelActive: false,
            isTruckEventModalActive: false,
            contextModal: false,
            notTerminated: true,
            contextType: '',
            loading: false,
            formData: {},
            promptIcon: '',
            promptTitle: '',
            promptMessage: '',
            modalClass: '',
        }
    },
    methods: {
        closeContextMenu() {
            this.$emit('close')
        },
        openEventModal() {
            this.isTruckEventModalActive = true;
        },
        closeBulkTruckEventModal() {
            $("#bulk-truck-event-modal").modal('hide');
            this.isTruckEventModalActive = false;
        },
        openActionModal(context) {
            this.contextModal = true;
            this.contextType = context;
        },
        cancelled() {
            this.confirmationModelActive = false;
        },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
        },
    },
    computed: {
        
    }
}
</script>